// extracted by mini-css-extract-plugin
export var menuIcon = "_s7-0";
export var menuIconInline = "_s7-1";